import React from "react";
import { Table, Button, Flex } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import EditableCell from "../editableCell/EditableCell";

const TableSelfcareAttributes = (props) => {
    const columns = [
        {
            title: "Id",
            dataIndex: "sca_id",
            key: "sca_id",
            align: "center",
        },
        {
            title: "Atributo de autocuidado",
            dataIndex: "sca_attribute",
            key: "sca_attribute",
            editable: true,
        },
        {
            title: "",
            dataIndex: "sca_actions",
            key: "sca_actions",
            align: "center",
            fixed: "right",
            width: 60,
            render: (text, row) => {
                return (
                    <Flex gap="small" wrap>
                        <Button
                            onClick={() => setSelfcareAttributeValuesToSee(row)}
                            style={{ backgroundColor: "#293790", color: "white" }}
                            icon={<EyeOutlined />}
                            size={"large"}
                            title="Ver atributo"
                        />
                    </Flex>
                );
            },
        },
    ];

    const setSelfcareAttributeValuesToSee = (sca) => {
        props.setSelfcareAttributeValuesToSee(sca);
    };

    return (
        <Table
            className="custom-green-table"
            size="small"
            dataSource={props.data}
            columns={columns}
            pagination={{ pageSize: 10, position: ["bottomRight"] }}
            scroll={{ x: "max-content" }}
            components={{ body: { cell: EditableCell } }}
        />
    );
};

export default TableSelfcareAttributes;
